import { Money } from '../../utilities';
import { I18n } from '../../wrappers';
export class OrderItemLocalizationSr {
    orderItem;
    constructor(orderItem) {
        this.orderItem = orderItem;
    }
    static getExemptFromTaxCode(key) {
        const reason = OrderItemLocalizationSr.exemptFromTaxReasons().find(r => key && r.key === key);
        return reason?.code || null;
    }
    static exemptFromTaxReasons() {
        const reasonLabel = (reason) => {
            const reasonText = I18n.t(`order.exempt_from_tax_reason.${reason.code}`);
            const category = reason.category ? `(${reason.category}) ` : '';
            return category + reason.code + ': ' + reasonText;
        };
        let reasons = [
            { code: 'PDV-RS-OBJ', category: 'S20' },
            { code: 'PDV-RS-OBJ', category: 'S10' },
            { code: 'PDV-RS-10-2-1', category: 'AE20' },
            { code: 'PDV-RS-10-2-2', category: 'AE20' },
            { code: 'PDV-RS-10-2-3', category: 'AE20' },
            { code: 'PDV-RS-10-2-4', category: 'AE20' },
            { code: 'PDV-RS-10-2-5-1', category: 'AE20' },
            { code: 'PDV-RS-10-2-5-2', category: 'AE20' },
            { code: 'PDV-RS-10-2-5-3', category: 'AE20' },
            { code: 'PDV-RS-10-2-5-3-OBJ', category: 'AE20' },
            { code: 'PDV-RS-36b-6', category: 'AE20' },
            { code: 'PDV-RS-10-2-1', category: 'AE10' },
            { code: 'PDV-RS-10-2-2', category: 'AE10' },
            { code: 'PDV-RS-10-2-3', category: 'AE10' },
            { code: 'PDV-RS-10-2-4', category: 'AE10' },
            { code: 'PDV-RS-10-2-5-1', category: 'AE10' },
            { code: 'PDV-RS-10-2-5-2', category: 'AE10' },
            { code: 'PDV-RS-10-2-5-3', category: 'AE10' },
            { code: 'PDV-RS-10-2-5-3-OBJ', category: 'AE10' },
            { code: 'PDV-RS-11-1-1', category: 'O' },
            { code: 'PDV-RS-11-1-2', category: 'O' },
            { code: 'PDV-RS-11-1-3', category: 'O' },
            { code: 'PDV-RS-11-1-4', category: 'O' },
            { code: 'PDV-RS-11-1-5', category: 'O' },
            { code: 'PDV-RS-11-3', category: 'O' },
            { code: 'PDV-RS-12-4', category: 'O' },
            { code: 'PDV-RS-12-6-1', category: 'O' },
            { code: 'PDV-RS-12-6-2', category: 'O' },
            { code: 'PDV-RS-12-6-3', category: 'O' },
            { code: 'PDV-RS-12-6-4-1', category: 'O' },
            { code: 'PDV-RS-12-6-4-2', category: 'O' },
            { code: 'PDV-RS-12-6-4-3', category: 'O' },
            { code: 'PDV-RS-12-6-4-4', category: 'O' },
            { code: 'PDV-RS-12-6-4-5', category: 'O' },
            { code: 'PDV-RS-12-6-5', category: 'O' },
            { code: 'PDV-RS-12-6-6', category: 'O' },
            { code: 'PDV-RS-12-6-7-1', category: 'O' },
            { code: 'PDV-RS-12-6-7-2', category: 'O' },
            { code: 'PDV-RS-12-6-7-3', category: 'O' },
            { code: 'PDV-RS-12-6-7-4', category: 'O' },
            { code: 'PDV-RS-12-6-7-5', category: 'O' },
            { code: 'PDV-RS-12-6-7-6', category: 'O' },
            { code: 'PDV-RS-12-6-7-7', category: 'O' },
            { code: 'PDV-RS-12-6-7-8', category: 'O' },
            { code: 'PDV-RS-12-6-7-9', category: 'O' },
            { code: 'PDV-RS-12-6-7-10', category: 'O' },
            { code: 'PDV-RS-12-6-7-11', category: 'O' },
            { code: 'PDV-RS-12-6-7-12', category: 'O' },
            { code: 'PDV-RS-12-6-8', category: 'O' },
            { code: 'PDV-RS-12-9', category: 'O' },
            { code: 'PDV-RS-61', category: 'O' },
            { code: 'PDV-RS-25-1-1', category: 'E' },
            { code: 'PDV-RS-25-1-1a', category: 'E' },
            { code: 'PDV-RS-25-1-2', category: 'E' },
            { code: 'PDV-RS-25-1-3', category: 'E' },
            { code: 'PDV-RS-25-1-4', category: 'E' },
            { code: 'PDV-RS-25-1-5', category: 'E' },
            { code: 'PDV-RS-25-1-6', category: 'E' },
            { code: 'PDV-RS-25-1-7', category: 'E' },
            { code: 'PDV-RS-25-1-8', category: 'E' },
            { code: 'PDV-RS-25-2-1', category: 'E' },
            { code: 'PDV-RS-25-2-2', category: 'E' },
            { code: 'PDV-RS-25-2-3', category: 'E' },
            { code: 'PDV-RS-25-2-3a', category: 'E' },
            { code: 'PDV-RS-25-2-3b', category: 'E' },
            { code: 'PDV-RS-25-2-5', category: 'E' },
            { code: 'PDV-RS-25-2-6', category: 'E' },
            { code: 'PDV-RS-25-2-7', category: 'E' },
            { code: 'PDV-RS-25-2-8', category: 'E' },
            { code: 'PDV-RS-25-2-9', category: 'E' },
            { code: 'PDV-RS-25-2-10', category: 'E' },
            { code: 'PDV-RS-25-2-11', category: 'E' },
            { code: 'PDV-RS-25-2-12', category: 'E' },
            { code: 'PDV-RS-25-2-13', category: 'E' },
            { code: 'PDV-RS-25-2-14', category: 'E' },
            { code: 'PDV-RS-25-2-15', category: 'E' },
            { code: 'PDV-RS-25-2-16', category: 'E' },
            { code: 'PDV-RS-25-2-17', category: 'E' },
            { code: 'PDV-RS-25-2-18', category: 'E' },
            { code: 'PDV-RS-25-2-19', category: 'E' },
            { code: 'PDV-RS-6-1-1', category: 'R' },
            { code: 'PDV-RS-6a', category: 'R' },
            { code: 'PDV-RS-6-ostalo', category: 'R' },
            { code: 'PDV-RS-24-1-1', category: 'Z' },
            { code: 'PDV-RS-24-1-2', category: 'Z', key: 'export' },
            { code: 'PDV-RS-24-1-3', category: 'Z' },
            { code: 'PDV-RS-24-1-5', category: 'Z' },
            { code: 'PDV-RS-24-1-5a', category: 'Z' },
            { code: 'PDV-RS-24-1-6', category: 'Z' },
            { code: 'PDV-RS-24-1-6a', category: 'Z' },
            { code: 'PDV-RS-24-1-7', category: 'Z' },
            { code: 'PDV-RS-24-1-7a', category: 'Z' },
            { code: 'PDV-RS-24-1-8', category: 'Z' },
            { code: 'PDV-RS-24-1-9', category: 'Z' },
            { code: 'PDV-RS-24-1-10', category: 'Z' },
            { code: 'PDV-RS-24-1-11', category: 'Z' },
            { code: 'PDV-RS-24-1-12', category: 'Z' },
            { code: 'PDV-RS-24-1-13', category: 'Z' },
            { code: 'PDV-RS-24-1-14', category: 'Z' },
            { code: 'PDV-RS-24-1-15', category: 'Z' },
            { code: 'PDV-RS-24-1-16-1', category: 'Z', key: 'diplomat' },
            { code: 'PDV-RS-24-1-16-2', category: 'Z' },
            { code: 'PDV-RS-24-1-16-3', category: 'Z' },
            { code: 'PDV-RS-24-1-16-4', category: 'Z' },
            { code: 'PDV-RS-24-1-16a', category: 'Z' },
            { code: 'PDV-RS-24-1-16b', category: 'Z' },
            { code: 'PDV-RS-24-1-16v', category: 'Z' },
            { code: 'PDV-RS-24-1-16g', category: 'Z' },
            { code: 'PDV-RS-24-1-17', category: 'Z' },
            { code: 'PDV-RS-33', category: 'SS', key: 'disabled' },
            { code: 'PDV-RS-35-7', category: 'SS' },
            { code: 'PDV-RS-36-5', category: 'SS' },
            { code: 'PDV-RS-36b-4', category: 'SS' },
            { code: 'PDV-RS-7a-4', category: 'OE' },
            { code: 'PDV-RS-9', category: 'OE' },
            { code: 'PDV-RS-17-4-2', category: 'OE' },
            { code: 'PDV-RS-17-4-3', category: 'OE' },
            { code: 'PDV-RS-4-4-2NP', category: 'OE' },
            { code: 'PDV-RS-5-4-2NP', category: 'OE' },
            { code: 'PDV-RS-3NP-ostalo', category: 'OE' },
            { code: 'PDV-RS-4', category: 'N' },
            { code: 'PDV-RS-5', category: 'N' },
            { code: 'PDV-RS-6-1-1 (BN)', category: 'N' },
            { code: 'PDV-RS-3-DZ', category: 'N' },
        ];
        return reasons.map(r => {
            r.label = reasonLabel(r);
            return r;
        });
    }
    getPriceBeforeTax() {
        if (this.orderItem.reverse_calculation) {
            const value = this.orderItem.getUnitPriceAfterDiscountBeforeTax()
                .multiply(this.orderItem.getCount());
            return Money.parse(value.toFormat('0.0000'));
        }
        const value = this.orderItem.getToPay().subtract(this.orderItem.getTax());
        return Money.parse(value.toFormat('0.0000'));
    }
}
const OrderItemLocalizationSrStatic = OrderItemLocalizationSr;
//# sourceMappingURL=OrderItemLocalizationSr.js.map